export const generatePDF = async (
  painLevelsData,
  formData,
  modules = null,
  fieldsMap = null,
  isFollowUp = false,
  tenantLogoUrl = null
) => {
  const { generatePDF: generatePDFImplementation } = await import('./pdfGeneratorImplementation');
  return generatePDFImplementation(
    painLevelsData,
    formData,
    modules,
    fieldsMap,
    isFollowUp,
    tenantLogoUrl
  );
};
